






// Import vendors ----------------------------------------------------------------------------------
import { defineComponent } from '@vue/composition-api';
import { useService } from '@xstate/vue';
// Import plugins ----------------------------------------------------------------------------------
import { usePodocore } from '@/plugins/podocore';
// Import components -------------------------------------------------------------------------------
import AuthResetPassword from '@/components/auth/resetPassword/AuthResetPassword.vue';
// -------------------------------------------------------------------------------------------------
export default defineComponent({
  name: 'PageAuthResetPassword',
  components: { AuthResetPassword },
  setup() {
    const authService = useService(usePodocore().getModuleService('auth'));

    return {
      authService
    };
  }
});
